// extracted by extract-css-chunks-webpack-plugin
module.exports = {"text":"_2mHKeX","lineThrough":"xZ2MLK","inChronicle":"_1nnmDO","accent":"DB7cYO"};